import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type FeatureFlag = {
  id: string;
  key: string;
  label: string;
  enabled: boolean;
  coming_soon: boolean;
  updated_at: string;
};

/**
 * Loads all feature flags via a security-definer RPC that returns only the
 * safe subset (no internal `notes`). Anonymous users get an empty list, and
 * the UI falls back to hardcoded defaults in src/data/tools.ts.
 */
export const useFeatureFlags = () => {
  const query = useQuery({
    queryKey: ["feature-flags"],
    staleTime: 30_000,
    queryFn: async (): Promise<Record<string, FeatureFlag>> => {
      const { data, error } = await supabase.rpc("get_public_feature_flags");
      if (error) return {};
      const map: Record<string, FeatureFlag> = {};
      for (const row of (data ?? []) as FeatureFlag[]) map[row.key] = row;
      return map;
    },
  });

  return {
    flags: query.data ?? {},
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
};
